import React, { useState } from 'react';

import moment from 'moment';
import { MobileDataControl } from '../MobileDataControl';

import './MobileDataYearly.scss';

/**
 * @param {object} props
 * @param {(value: { year: number, month: number, day: number }) => void} props.onChange
 * @param {number} props.value
 * @param {number[]} props.providedYear
 */
export const MobileDataYearly = (props) => {
  const { onChange, providedYear, value } = props;

  const now = moment();
  const startDecadeYear = Math.floor((now.year() - 1) / 10) * 10 + 1;
  const [startYear, setStartYear] = useState(startDecadeYear);

  const rulesYear = (year) => {
    const yearNow = now.year();
    const monthNow = now.month() + 1;
    const dateNow = now.date();
    if (year === yearNow - 1 && monthNow <= 2 && dateNow < 9) {
      return true;
    }
    if (year === yearNow) {
      return true;
    }
    return !providedYear.includes(year);
  };

  const activeYear = (year) => {
    const yearNow = now.year();
    const monthNow = now.month() + 1;
    const dateNow = now.date();
    if (
      value - 1 === year &&
      yearNow === value &&
      monthNow >= 2 &&
      dateNow < 9
    ) {
      return true;
    } else if (value === yearNow && value - 1 === year) {
      return true;
    } else if (value !== yearNow) {
      return value === year;
    }
    return false;
  };

  const Years = () => {
    const years = [];
    for (let i = 0; i < 10; i++) {
      years.push(startYear + i);
    }
    return years.map((year) => (
      <button
        className={`list-year-item${activeYear(year) ? ' active' : ''}`}
        disabled={rulesYear(year)}
        key={year}
        onClick={() => onChange({ year, month: 0, day: 0 })}
      >
        {year}
      </button>
    ));
  };

  return (
    <div className='feature-genset-MD MobileDataYearly'>
      <MobileDataControl
        disabledNext={startYear + 10 > now.year()}
        disabledPrev={false}
        onNext={() => {
          if (startYear + 10 < now.year()) {
            setStartYear(startYear + 10);
          }
        }}
        onPrev={() => {
          setStartYear(startYear - 10);
        }}
      >
        <div className='range-year'>
          {startYear} - {startYear + 9}
        </div>
      </MobileDataControl>
      <div className='list-year'>
        <Years />
      </div>
    </div>
  );
};
